import React from 'react';
import { Accessibility, Mail, Phone } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { contactData } from '../data/mock';

export default function AccessibilityStatement() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main id="main-content" tabIndex={-1} className="pt-32 pb-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 rounded-full bg-teal-50 flex items-center justify-center">
              <Accessibility className="w-6 h-6 text-teal-700" aria-hidden="true" />
            </div>
            <h1
              className="text-4xl sm:text-5xl font-bold text-slate-900"
              style={{ fontFamily: "'Playfair Display', serif" }}
              data-testid="accessibility-statement-title"
            >
              Accessibility Statement
            </h1>
          </div>

          <div className="space-y-6 text-slate-700 leading-relaxed">
            <p>
              The DC Early Learning Collaborative (DCELC) is committed to ensuring digital
              accessibility for people with disabilities. We are continually improving the user
              experience for everyone and applying the relevant accessibility standards.
            </p>

            <h2 className="text-lg font-bold text-slate-900 pt-2">Conformance Status</h2>
            <p>
              We strive to conform to the{' '}
              <a
                href="https://www.w3.org/TR/WCAG21/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-teal-700 underline hover:text-teal-800"
              >
                Web Content Accessibility Guidelines (WCAG) 2.1, Level AA
              </a>
              . Our site includes features such as keyboard navigation, visible focus indicators,
              a skip-to-content link, captioned videos, screen-reader-compatible forms and
              landmarks, and color contrast that meets AA minimums. Accessibility is an ongoing
              effort, and we review the site regularly as new content is added.
            </p>

            <h2 className="text-lg font-bold text-slate-900 pt-2">Feedback</h2>
            <p>
              If you encounter any accessibility barriers on this website, or need information in
              an alternative format, please let us know. We take all feedback seriously and will
              work to address issues promptly.
            </p>
            <ul className="space-y-2">
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-teal-700" aria-hidden="true" />
                <a
                  href={`mailto:${contactData.email}?subject=Website%20Accessibility%20Feedback`}
                  className="text-teal-700 underline hover:text-teal-800"
                  data-testid="accessibility-feedback-email"
                >
                  {contactData.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-teal-700" aria-hidden="true" />
                <a href={`tel:${contactData.phone}`} className="text-teal-700 underline hover:text-teal-800">
                  {contactData.phone}
                </a>
              </li>
            </ul>

            <p className="text-sm text-slate-500 pt-4">Last reviewed: June 2026</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
